
// Define UIActionKey type inline since we can't import it
type UIActionKey = 
  | 'cancel'
  | 'save'
  | 'delete'
  | 'edit'
  | 'close'
  | 'apply'
  | 'or'
  | 'selectFile'
  | 'dragToUpload'
  | 'copied'
  | 'preview'
  | 'saveAll'
  | 'change'
  | 'remove'
  | 'saveChanges'
  | 'updatePassword'
  | 'all'
  | 'completed'
  | 'status';

export const uiActions: Record<UIActionKey, string> = {
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  apply: 'Apply',
  or: 'or',
  selectFile: 'Select File',
  dragToUpload: 'Drag to upload',
  copied: 'Copied',
  preview: 'Preview',
  saveAll: 'Save All',
  change: 'Change',
  remove: 'Remove',
  saveChanges: 'Save Changes',
  updatePassword: 'Update Password',
  all: 'All',
  completed: 'Completed',
  status: 'Status'
};
